module.exports = __webpack_public_path__ + "tr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tr.svg
// module id = 852
// module chunks = 0